import type { ReactNode } from 'react';

export const symbol_voice_selection_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M757.5-609q11.5 0 19.5 9 44 51 68.5 114.5T870-350q0 30-4.5 59T852-233q-4 12-15 17.5t-23 1.5q-12-4-18-15t-2-23q26-80 10-160.5T734-557q-8-9-7-21.5t10-21.5q9-9 20.5-9ZM331-805q-6-11-1.5-23.5T345-847q11-6 23-1.5t18 15.5l96 186q5 11 1 23t-15 17q-11 6-23 1.5T427-621l-96-184ZM160-336v-59q0-13 8.5-21.5T190-425h130v-100q0-13 8.5-21.5T350-555h55l60 60h-85v60q0 29-20.5 49.5T310-365h-90v29q0 38 23.5 67.5T304-229l12 3q33 8 37 41t-26 50q-50 28-105 40.5T110-80q-12 1-21-7.5T80-109q0-13 8.5-21.5T110-140q42-2 83-10.5t81-23.5q-49-24-81.5-66T160-336ZM812-63 47-827q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l765 765q9 9 9 21t-9 21q-9 9-21.5 9T812-63Z"
		/>
	</svg>
);
